import React, { memo } from "react";
import { UserCard } from "./UserCard";
import { Users } from "lucide-react";

// Simple user list component - no virtualization, just a long scrollable list (like Assets.js)
export const VirtualizedUserList = memo(({ 
  users, 
  currentUser, 
  roleLabels, 
  roleBadgeColors, 
  onEdit, 
  onResetPin, 
  onToggleActive, 
  onDelete,
  canEdit = true,
  canResetPin = true,
  canToggleActive = true
}) => {
  if (users.length === 0) {
    return (
      <div className="text-center py-8 text-slate-500">
        <Users className="w-12 h-12 mx-auto mb-3 opacity-50" />
        <p>No users found</p>
      </div>
    );
  }

  return (
    <div className="space-y-3 sm:space-y-2">
      {users.map((user) => (
        <UserCard
          key={user.id}
          user={user}
          currentUser={currentUser}
          roleLabels={roleLabels}
          roleBadgeColors={roleBadgeColors}
          onEdit={canEdit ? onEdit : null}
          onResetPin={canResetPin ? onResetPin : null}
          onToggleActive={canToggleActive ? onToggleActive : null}
          onDelete={onDelete}
        />
      ))}
      <div className="text-center py-4 text-xs text-slate-400">
        {users.length} users
      </div>
    </div>
  );
});

VirtualizedUserList.displayName = 'VirtualizedUserList';
